export const icons = {
  home: {
    sm: require('assets/icons/home.png'),
    md: require('assets/icons/home@2x.png'),
    lg: require('assets/icons/home@3x.png'),
  },
  project: {
    sm: require('assets/icons/projects.png'),
    md: require('assets/icons/projects@2x.png'),
    lg: require('assets/icons/projects@3x.png'),
  },
  team: {
    sm: require('assets/icons/team.png'),
    md: require('assets/icons/team@2x.png'),
    lg: require('assets/icons/team@3x.png'),
  },
  settings: {
    sm: require('assets/icons/settings.png'),
    md: require('assets/icons/settings@2x.png'),
    lg: require('assets/icons/settings@3x.png'),
  },

  ai_search: {
    sm: require('assets/icons/ai-search.png'),
    md: require('assets/icons/ai-search@2x.png'),
    lg: require('assets/icons/ai-search@3x.png'),
  },
  cheveron_down: {
    sm: require('assets/icons/cheveron_down.png'),
    md: require('assets/icons/cheveron_down@2x.png'),
    lg: require('assets/icons/cheveron_down@3x.png'),
  },
  edit_blue: {
    sm: require('assets/icons/Edit-blue.png'),
    md: require('assets/icons/Edit-blue@2x.png'),
    lg: require('assets/icons/Edit-blue@3x.png'),
  },
  back_arrow: {
    sm: require('assets/icons/back-arrow.png'),
    md: require('assets/icons/back-arrow@2x.png'),
    lg: require('assets/icons/back-arrow@3x.png'),
  },
  priority: {
    sm: require('assets/icons/priority.png'),
    md: require('assets/icons/priority@2x.png'),
    lg: require('assets/icons/priority@3x.png'),
  },
  edit_white: {
    sm: require('assets/icons/edit-white.png'),
    md: require('assets/icons/edit-white@2x.png'),
    lg: require('assets/icons/edit-white@3x.png'),
  },
  search: {
    sm: require('assets/icons/search.png'),
    md: require('assets/icons/search@2x.png'),
    lg: require('assets/icons/search@3x.png'),
  },

  star_yellow: {
    sm: require('assets/icons/star_yellow.png'),
    md: require('assets/icons/star_yellow@2x.png'),
    lg: require('assets/icons/star_yellow@3x.png'),
  },
  star_gray: {
    sm: require('assets/icons/star_gray.png'),
    md: require('assets/icons/star_gray@2x.png'),
    lg: require('assets/icons/star_gray@3x.png'),
  },

  plus: {
    sm: require('assets/icons/plus.png'),
    md: require('assets/icons/plus@2x.png'),
    lg: require('assets/icons/plus@3x.png'),
  },

  cross_white: {
    sm: require('assets/icons/cross_white.png'),
    md: require('assets/icons/cross_white@2x.png'),
    lg: require('assets/icons/cross_white@3x.png'),
  },
  trash_white: {
    sm: require('assets/icons/trash_white.png'),
    md: require('assets/icons/trash_white@2x.png'),
    lg: require('assets/icons/trash_white@3x.png'),
  },
  responsible: {
    sm: require('assets/icons/responsible.png'),
    md: require('assets/icons/responsible@2x.png'),
    lg: require('assets/icons/responsible@3x.png'),
  },
  clock: {
    sm: require('assets/icons/clock.png'),
    md: require('assets/icons/clock@2x.png'),
    lg: require('assets/icons/clock@3x.png'),
  },
  reset_password_blue: {
    sm: require('assets/icons/reset_password_blue.png'),
    md: require('assets/icons/reset_password_blue@2x.png'),
    lg: require('assets/icons/reset_password_blue@3x.png'),
  },
  camera_blue: {
    sm: require('assets/icons/camera_blue.png'),
    md: require('assets/icons/camera_blue@2x.png'),
    lg: require('assets/icons/camera_blue@3x.png'),
  },
  cross: {
    sm: require('assets/icons/cross.png'),
    md: require('assets/icons/cross@2x.png'),
    lg: require('assets/icons/cross@3x.png'),
  },
  gallery: {
    sm: require('assets/icons/gallery.png'),
    md: require('assets/icons/gallery@2x.png'),
    lg: require('assets/icons/gallery@3x.png'),
  },
  cheveron_right_grey: {
    sm: require('assets/icons/cheveron_right_grey.png'),
    md: require('assets/icons/cheveron_right_grey@2x.png'),
    lg: require('assets/icons/cheveron_right_grey@3x.png'),
  },
  validate_tick: {
    sm: require('assets/icons/validate_tick.png'),
    md: require('assets/icons/validate_tick@2x.png'),
    lg: require('assets/icons/validate_tick@3x.png'),
  },
  revoke_cross: {
    sm: require('assets/icons/revoke_cross.png'),
    md: require('assets/icons/revoke_cross@2x.png'),
    lg: require('assets/icons/revoke_cross@3x.png'),
  },
  trash: {
    sm: require('assets/icons/trash.png'),
    md: require('assets/icons/trash@2x.png'),
    lg: require('assets/icons/trash@3x.png'),
  },
  cheveron_down_white: {
    sm: require('assets/icons/cheveron_down_white.png'),
    md: require('assets/icons/cheveron_down_white@2x.png'),
    lg: require('assets/icons/cheveron_down_white@3x.png'),
  },

  //navbar related menus
  home_gray: {
    sm: require('assets/icons/home-gray.png'),
    md: require('assets/icons/home-gray@2x.png'),
    lg: require('assets/icons/home-gray@3x.png'),
  },
  home_white: {
    sm: require('assets/icons/home-white.png'),
    md: require('assets/icons/home-white@2x.png'),
    lg: require('assets/icons/home-white@3x.png'),
  },

  projects_gray: {
    sm: require('assets/icons/projects-gray.png'),
    md: require('assets/icons/projects-gray@2x.png'),
    lg: require('assets/icons/projects-gray@3x.png'),
  },
  projects_white: {
    sm: require('assets/icons/projects-white.png'),
    md: require('assets/icons/projects-white@2x.png'),
    lg: require('assets/icons/projects-white@3x.png'),
  },

  team_gray: {
    sm: require('assets/icons/team-gray.png'),
    md: require('assets/icons/team-gray@2x.png'),
    lg: require('assets/icons/team-gray@3x.png'),
  },
  team_white: {
    sm: require('assets/icons/team-white.png'),
    md: require('assets/icons/team-white@2x.png'),
    lg: require('assets/icons/team-white@3x.png'),
  },

  organisation_settings_gray: {
    sm: require('assets/icons/organisation-settings-gray.png'),
    md: require('assets/icons/organisation-settings-gray@2x.png'),
    lg: require('assets/icons/organisation-settings-gray@3x.png'),
  },
  organisation_settings_white: {
    sm: require('assets/icons/organisation-settings-white.png'),
    md: require('assets/icons/organisation-settings-white@2x.png'),
    lg: require('assets/icons/organisation-settings-white@3x.png'),
  },

  training_gray: {
    sm: require('assets/icons/training-gray.png'),
    md: require('assets/icons/training-gray@2x.png'),
    lg: require('assets/icons/training-gray@3x.png'),
  },
  training_white: {
    sm: require('assets/icons/training-white.png'),
    md: require('assets/icons/training-white@2x.png'),
    lg: require('assets/icons/training-white@3x.png'),
  },

  documentation_gray: {
    sm: require('assets/icons/documentation-gray.png'),
    md: require('assets/icons/documentation-gray@2x.png'),
    lg: require('assets/icons/documentation-gray@3x.png'),
  },
  documentation_white: {
    sm: require('assets/icons/documentation-white.png'),
    md: require('assets/icons/documentation-white@2x.png'),
    lg: require('assets/icons/documentation-white@3x.png'),
  },

  assets_gray: {
    sm: require('assets/icons/assests-gray.png'),
    md: require('assets/icons/assests-gray@2x.png'),
    lg: require('assets/icons/assests-gray@3x.png'),
  },
  assets_white: {
    sm: require('assets/icons/assests-white.png'),
    md: require('assets/icons/assests-white@2x.png'),
    lg: require('assets/icons/assests-white@3x.png'),
  },

  forum_gray: {
    sm: require('assets/icons/forum-gray.png'),
    md: require('assets/icons/forum-gray@2x.png'),
    lg: require('assets/icons/forum-gray@3x.png'),
  },
  forum_white: {
    sm: require('assets/icons/forum-white.png'),
    md: require('assets/icons/forum-white@2x.png'),
    lg: require('assets/icons/forum-white@3x.png'),
  },

  chat_gray: {
    sm: require('assets/icons/chat-gray.png'),
    md: require('assets/icons/chat-gray@2x.png'),
    lg: require('assets/icons/chat-gray@3x.png'),
  },
  chat_white: {
    sm: require('assets/icons/chat-white.png'),
    md: require('assets/icons/chat-white@2x.png'),
    lg: require('assets/icons/chat-white@3x.png'),
  },

  account_settings_gray: {
    sm: require('assets/icons/account-settings-gray.png'),
    md: require('assets/icons/account-settings-gray@2x.png'),
    lg: require('assets/icons/account-settings-gray@3x.png'),
  },
  account_settings_white: {
    sm: require('assets/icons/account-settings-white.png'),
    md: require('assets/icons/account-settings-white@2x.png'),
    lg: require('assets/icons/account-settings-white@3x.png'),
  },

  logout_gray: {
    sm: require('assets/icons/logout-gray.png'),
    md: require('assets/icons/logout-gray@2x.png'),
    lg: require('assets/icons/logout-gray@3x.png'),
  },
  logout_white: {
    sm: require('assets/icons/logout-white.png'),
    md: require('assets/icons/logout-white@2x.png'),
    lg: require('assets/icons/logout-white@3x.png'),
  },

  manage_org_gray: {
    sm: require('assets/icons/manage-org-gray.png'),
    md: require('assets/icons/manage-org-gray@2x.png'),
    lg: require('assets/icons/manage-org-gray@3x.png'),
  },
  manage_org_white: {
    sm: require('assets/icons/manage-org-white.png'),
    md: require('assets/icons/manage-org-white@2x.png'),
    lg: require('assets/icons/manage-org-white@3x.png'),
  },
} as const;

export type IconType = keyof typeof icons;
